import { render, staticRenderFns } from "./ButtonPrevious.vue?vue&type=template&id=4022b718&"
import script from "./ButtonPrevious.vue?vue&type=script&lang=js&"
export * from "./ButtonPrevious.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports